import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';

import { RiskLink } from '../risk-link/risk-link';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationRiskCountProps {
  assetId: string;
}

export const AssetInformationRiskCount = ({
  assetId,
}: AssetInformationRiskCountProps) => {
  const { t } = useTranslation('ads', {
    keyPrefix: 'fields',
  });
  const { data: device } = useDeviceDetails(assetId);
  const { risk } = device ?? {};

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      term={t('riskCount')}
      skeletonProps={{ width: '6rem' }}
    >
      <RiskLink assetId={assetId} value={risk?.count} />
    </AssetInformationFieldWrapper>
  );
};
